<template>
  <div class="write-report">
    <div class="write-report-text">
      <el-input
        type="textarea"
        :autosize="{ minRows: 8, maxRows: 8}"
        placeholder="请您输入对以上内容学习后的思想准备"
        v-model="textarea"
        maxlength="200"
        show-word-limit
      ></el-input>
    </div>
    <div class="write-report-button" @click="sumbit()">
      <button>确认提交</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      textarea: ""
    };
  },
  mounted() {},
  methods: {
    sumbit() {
      if (this.textarea != "") {
        let msg = {
          name: sessionStorage.getItem("name"),
          userid: sessionStorage.getItem("id"),
          studyid: this.$route.query.studyid,
          img: sessionStorage.getItem("imgheader"),
          title: this.textarea,
          time: new Date()
        };

        this.axios.post("/api/Index/PostAddReport", msg).then(e => {
          if (e.data.code == 0) {
            this.$message({
              message: "提交成功",
              offset: 200,
              type: "success"
            });
          }else{
            this.$message({
              message: "提交失败，请稍重试",
              offset: 200,
              type: "error"
            });
          }
        });
      } else {
        this.$message({
          message: "未填写任何信息",
          offset: 200,
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.write-report {
  &-button {
    button {
      width: 7.1rem;
      height: 0.9rem;
      background: linear-gradient(
        1deg,
        rgba(249, 185, 77, 1),
        rgba(253, 203, 118, 1)
      );
      box-shadow: 1px 8px 8px 0px rgba(0, 0, 0, 0.08);
      border-radius: 0.08rem;
      border: none;
      color: #fff;
    }
    position: fixed;
    width: 100%;
    bottom: 1rem;
    text-align: center;
  }
  &-text {
    padding: 0.2rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>